import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import React from "react";
export var Section = function(_param) {
    var children = _param.children, bg = _param.bg, className = _param.className, tmp = _param.degree, _degree = tmp === void 0 ? 2 : tmp, rest = _object_without_properties(_param, [
        "children",
        "bg",
        "className",
        "degree"
    ]);
    // const { bg } = rest
    var degreeStr = _degree.toFixed(1);
    var styles = {
        background: bg,
        width: "100%",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: "absolute",
        transform: "skewY(".concat(degreeStr, "deg)"),
        transformOrigin: "center"
    };
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: "relative"
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: _object_spread({}, styles)
            }),
            /*#__PURE__*/ _jsx("div", {
                style: _object_spread_props(_object_spread({}, styles), {
                    transform: "skewY(".concat(degreeStr + 2, "deg)"),
                    opacity: 0.2,
                    transformOrigin: "60%"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                style: _object_spread({
                    transform: "skewY(".concat(degreeStr + 3, "deg)"),
                    transformOrigin: "70%",
                    opacity: 0.1
                }, styles)
            }),
            /*#__PURE__*/ _jsx("div", {
                className: clsx("flex flex-col items-stretch w-full max-w-full", className),
                children: children
            })
        ]
    }));
};
